import { message, Modal } from 'antd';
import { ExclamationCircleOutlined } from "@ant-design/icons";

import useAppDispatch from '../../../redux/hooks/useAppDispatch';
import { refreshTableKitsProducts } from '../../../redux';
import { useKitsProducts } from './useKitsProducts';
import { kitsProductsService } from '../../../shared/services';

const { confirm } = Modal;

export const useTableKitsProducts = () => {
    const dispatch = useAppDispatch();
    const { tableProps } = useKitsProducts();

    const showDeleteConfirm = (valId: number, val: string) => {
        confirm({
          title: `Estás seguro de borrar el producto del kit con el id: ${valId}`,
          icon: <ExclamationCircleOutlined />,
          content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar producto del kit" en caso tal solo oprime en "Cancelar".`,
          okText: "Borrar producto del kit",
          okType: "danger",
          cancelText: "Cancelar",
          async onOk() {
            await deleteProductForKit(valId)
              .then(() => {
                dispatch(refreshTableKitsProducts(true));
                message.success(`Se ha borrado el producto del kit con id:${valId}`);
                tableProps?.refresh();
              })
              .catch((err) => {
                console.log({ err });
                message.error(err.message);
              });
          },
          onCancel() {},
        });
      };

      
      const deleteProductForKit = async(id: number) =>{
        return  await kitsProductsService.remove(id.toString())
        .then((res: any) => {return res})
        .catch((err: any) => { return err.message })
    }
    return {
        showDeleteConfirm,
    }
}
